import { Injectable, inject, DOCUMENT } from '@angular/core';
import {
  AAL_ELIGIBLE_DATA,
  ACCOUNT_NUMBER,
  COOKIES_PAGE_USER_NAME,
  COOKIES_USER_INFO,
  DEEPLINK_STORAGE_KEY,
  GUID_KEY,
  PHONE_NUMBER,
} from '@rci/self-serve-fido/app.constant';
import { UserInformationStateFacade } from '@rci/self-serve-fido/state/user-information/user-information-state.facade';
import { ApiEndpointConfigService } from '@rci/self-serve-shared';
import { LOCAL_STORAGE, SESSION_STORAGE } from '@rogers/self-serve-utils/storage';
import { WindowService } from '@rogers/cdk/common/services';

const localStorageKeys = [ACCOUNT_NUMBER, PHONE_NUMBER, GUID_KEY, AAL_ELIGIBLE_DATA];

const LOGOUT_URL = '/profile/logout';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  private readonly config = inject(ApiEndpointConfigService);
  private readonly document = inject<Document>(DOCUMENT);
  private readonly localStorage = inject<Storage>(LOCAL_STORAGE);
  private readonly sessionStorage = inject<Storage>(SESSION_STORAGE);
  private readonly userInformationStateFacade = inject(UserInformationStateFacade);
  private readonly windowService = inject(WindowService);

  private readonly window: Window;

  constructor() {
    this.window = this.windowService.windowRef();
  }

  logOut(reLogin = false, retainDeepLink = false) {
    this.clearLoginState(retainDeepLink);

    const logOutUrl = reLogin ? `${LOGOUT_URL}?login=true` : LOGOUT_URL;
    this.window.open(logOutUrl, '_self');
  }

  private clearLoginState(retainDeepLink) {
    const cookiesToClear = [COOKIES_PAGE_USER_NAME, COOKIES_USER_INFO];
    cookiesToClear.forEach(cookie => {
      this.deleteCookie(cookie);
    });

    localStorageKeys.forEach(key => {
      this.localStorage.removeItem(key);
    });

    let deepLinkUrl = '';
    if (retainDeepLink) {
      deepLinkUrl = this.sessionStorage.getItem(DEEPLINK_STORAGE_KEY);
    }
    this.sessionStorage.clear();
    if (retainDeepLink) {
      this.sessionStorage.setItem(DEEPLINK_STORAGE_KEY, deepLinkUrl);
    }
    this.userInformationStateFacade.resetUserInformation();
  }

  private deleteCookie(name, path = '/') {
    this.document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
  }
}
